<template>
  <v-dialog v-model="dialogStampa" max-width="500">
    <v-card>
      <v-card-title class="text-h5">{{title}}</v-card-title>
      <v-card-text>{{message}}</v-card-text>
      <template v-if="isStampaEtichette">
        <v-list-item>
          <v-list-item-title class="pa-1">
            <v-select v-model="modelloEtichette" :items="modelliEtichette" dense flat outlined label="Modello Stampa" item-text="descrizione" item-value="codice" :return-object="true" @change="onChangeModello"></v-select>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title class="pa-1">
            <v-switch
              v-model="usaQuantitaAnagrafica"
              inset
              label="Usa quantità anagrafica"
            ></v-switch>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="usaQuantitaAnagrafica">
          <v-list-item-title>Forza quantità</v-list-item-title>
          <v-list-item-subtitle><v-text-field v-model="forzaQuantita" class="mt-3" dense outlined label="Forza quantità" clearable hide-details></v-text-field></v-list-item-subtitle>
        </v-list-item>
        <v-list-item @click="usaQuantitaAnagrafica=true">
          <v-list-item-title>Totale articoli</v-list-item-title>
          <v-list-item-subtitle>{{ totaleEtichette.totaleAnagrafica }}</v-list-item-subtitle>
          <v-list-item-icon>
            <v-icon v-show="usaQuantitaAnagrafica">mdi-printer</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="usaQuantitaAnagrafica=false">
          <v-list-item-title>Totale etichette</v-list-item-title>
          <v-list-item-subtitle>{{ totaleEtichette.totaleMovimenti }}</v-list-item-subtitle>
          <v-list-item-icon>
            <v-icon v-show="!usaQuantitaAnagrafica">mdi-printer</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <template v-if="isModuloA4">
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>Etichette da saltare su A4</v-list-item-title>
            <v-list-item-subtitle class="text-h6">{{daSaltare}}</v-list-item-subtitle>
          </v-list-item>
          <v-card-text>
            <v-slider v-model="daSaltare" color="green" thumb-label track-color="grey" always-dirty min="0" max="100">
              <template v-slot:prepend>
                <v-icon color="green" @click="decrement">mdi-minus</v-icon>
              </template>
              <template v-slot:append>
                <v-icon color="green" @click="increment">mdi-plus</v-icon>
              </template>
            </v-slider>
          </v-card-text>
        </template>
        <v-divider></v-divider>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="printConfirm">{{confirmText}}</v-btn>
        <v-btn color="blue darken-1" text @click="closePrint">{{cancelText}}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import configurazioni from '@/services/configurazioniService.js'

export default {
  props: {
    show: Boolean,
    title: { type: String, default: 'Errore aggiornamento' },
    confirmText: { type: String, default: 'SI' },
    cancelText: { type: String, default: 'NO' },
    message: { type: String, default: '' },
    isStampaEtichette: { type: Boolean, defaut: false },
    // isModuloA4: { type: Boolean, defaut: false },
    totaleEtichette: Object
  },
  data(vm) {
    return {
      dialogStampa: false,
      usaQuantitaAnagrafica: false,
      daSaltare: 0,
      modelliEtichette: [],
      modelloEtichette: null,
      isModuloA4: false,
      tipo: '',
      report: '',
      modelloDefault: null,
      forzaQuantita: ''
    }
  },
  watch: {
    show(value) {
      this.dialogStampa = value
    }
  },
  async mounted() {
      const impostazioniEtichette = await configurazioni.getConfigurazione('display_generale', 'etichette')
      const etichette = await configurazioni.getConfigurazione('etichette', 'report')
      this.modelliEtichette = etichette.filter(x => x.enabled).map(x => {
        return {
          codice: x.titolo,
          descrizione: x.descrizione,
          tipo: x.tipo,
          report: x.nomeReport
        }
      })
      this.modelloEtichette = this.modelliEtichette.find(x => x.codice === impostazioniEtichette.report) || this.modelliEtichette[0]
      this.onChangeModello(this.modelloEtichette)
  },
  methods: {
    printConfirm() {
      this.dialogStampa = false
      this.$emit('dialog-print', this.usaQuantitaAnagrafica, this.daSaltare, this.tipo, this.report, this.forzaQuantita)
    },
    closePrint() {
      this.dialogStampa = false
      this.$emit('dialog-cancel')
    },
    onChangeModello(modello) {
      this.isModuloA4 = modello.tipo === 'pdf'
      this.tipo = modello.tipo
      this.report = modello.codice
    },
    decrement () {
      this.daSaltare--
    },
    increment () {
      this.daSaltare++
    }
  }
}
</script>
